module.exports = __webpack_public_path__ + "img/smok_vape_1.a61a9199.png";